/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AddImageWrapper } from '@bingads-webui-campaign-react/asset-library-creative-components';
import { CSMLAssetSource } from '@bingads-webui-campaign-react/asset-library-model';

import { CreativeEditorView } from './creative-editor-view';

export const AssetLibraryCreativeEditor = ({
  addMediaConfig,
  assetLibraryConfig,
  creativeData,
  onRenderCTA,
  callToAction,
  onApplyCreative,
  onGenerateCreative,
  finalUrl,
  dataService,
  i18n,
  initialView,
  isAssetLibraryAIGCMVPEnabled,
  isOpen,
  logger,
  ...rest
}) => {
  const [showAddImagePanel, setShowAddImagePanel] = useState(false);
  const [newImageDataObject, setNewImageDataObject] = useState({});

  const {
    cid,
    aid,
    oDataConfig,
    fetchAigcTemplateDefinition,
  } = rest;

  return (
    <div className="creative-editor-with-add-image-wrapper">
      <CreativeEditorView
        creativeData={creativeData}
        newImageDataObject={newImageDataObject}
        i18n={i18n}
        onChangeImage={() => setShowAddImagePanel(true)}
        cid={cid}
        aid={aid}
        oDataConfig={oDataConfig}
        finalUrl={finalUrl}
        isOpen={isOpen}
        permissions={rest.permissions}
        dataService={dataService}
        assetLibraryConfig={assetLibraryConfig}
        callToAction={callToAction}
        onRenderCTA={onRenderCTA}
        setIsOpen={rest.setIsOpen}
        onApplyCreative={onApplyCreative}
        onGenerateCreative={onGenerateCreative}
        logger={logger}
        fetchAigcTemplateDefinition={fetchAigcTemplateDefinition}
      />
      <AddImageWrapper
        addMediaConfig={addMediaConfig}
        assetLibraryConfig={assetLibraryConfig}
        dataService={dataService}
        i18n={i18n}
        initialView={initialView}
        isAssetLibraryAIGCMVPEnabled={isAssetLibraryAIGCMVPEnabled}
        logger={logger}
        setNewImageDataObject={setNewImageDataObject}
        showAddImagePanel={showAddImagePanel}
        setShowAddImagePanel={setShowAddImagePanel}
        cid={cid}
        aid={aid}
        disabledAssetSources={[CSMLAssetSource.Shutterstock]}
        {...rest}
      />
    </div>
  );
};

AssetLibraryCreativeEditor.propTypes = {
  addMediaConfig: PropTypes.shape({}).isRequired,
  assetLibraryConfig: PropTypes.shape({}).isRequired,
  creativeData: PropTypes.shape({}).isRequired,
  dataService: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  initialView: PropTypes.string.isRequired,
  isAssetLibraryAIGCMVPEnabled: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  logger: PropTypes.shape({}).isRequired,
  onApplyCreative: PropTypes.func.isRequired,
  onGenerateCreative: PropTypes.func.isRequired,
  onRenderCTA: PropTypes.func,
  callToAction: PropTypes.shape({}),
  finalUrl: PropTypes.string,
};

AssetLibraryCreativeEditor.defaultProps = {
  onRenderCTA: () => {},
  callToAction: {},
  finalUrl: '',
};
